document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* =============================================
   * Header Scroll Shadow
   * ============================================= */
  (function initHeaderScroll() {
    var header = document.querySelector('.header');
    if (!header) return;

    var scrollThreshold = 50;

    function onScroll() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* =============================================
   * Mobile Menu Toggle
   * ============================================= */
  (function initMobileMenu() {
    var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
    var mobileMenu = document.querySelector('[data-mobile-menu]');
    var overlay = document.querySelector('[data-mobile-menu-overlay]');

    if (!menuToggle || !mobileMenu) return;

    function openMenu() {
      mobileMenu.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.classList.add('no-scroll');
      menuToggle.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('no-scroll');
      menuToggle.setAttribute('aria-expanded', 'false');
    }

    menuToggle.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.contains('is-open');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    var closeBtn = document.querySelector('[data-mobile-menu-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }
  })();

  /* =============================================
   * Mobile Submenu Accordion
   * ============================================= */
  (function initMobileSubmenu() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mobile-submenu-toggle]');
      if (!toggle) return;

      e.preventDefault();

      var parent = toggle.closest('.mobile-menu__nav-item');
      if (!parent) return;

      var submenu = parent.querySelector('.mobile-menu__sub, [data-mobile-submenu]');
      if (!submenu) return;

      var isOpen = submenu.classList.contains('is-visible');

      // Close all other open submenus at the same level
      var allSubmenus = document.querySelectorAll('.mobile-menu__sub.is-visible, [data-mobile-submenu].is-visible');
      allSubmenus.forEach(function (s) {
        if (s !== submenu) {
          s.classList.remove('is-visible');
          var siblingParent = s.closest('.mobile-menu__nav-item');
          if (siblingParent) {
            var siblingToggle = siblingParent.querySelector('[data-mobile-submenu-toggle]');
            if (siblingToggle) siblingToggle.setAttribute('aria-expanded', 'false');
          }
        }
      });

      if (isOpen) {
        submenu.classList.remove('is-visible');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        submenu.classList.add('is-visible');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  })();

  /* =============================================
   * Product Gallery Thumbnail Click
   * ============================================= */
  (function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var mainImageContainer = gallery.querySelector('[data-product-main-image]');
    if (!mainImageContainer) return;

    var mainImage = mainImageContainer.querySelector('img') || mainImageContainer;

    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('.product-gallery__thumb');
      if (!thumb) return;

      e.preventDefault();

      var newSrc = thumb.getAttribute('data-full-src');
      var newAlt = thumb.querySelector('img')?.alt || '';

      if (newSrc && mainImage.tagName === 'IMG') {
        mainImage.src = newSrc;
        mainImage.alt = newAlt;
      }

      // Update active state
      gallery.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  })();

  /* =============================================
   * Product Tabs
   * ============================================= */
  (function initProductTabs() {
    var tabContainers = document.querySelectorAll('[data-product-tabs], [data-tabs]');

    tabContainers.forEach(function (container) {
      var tabs = container.querySelectorAll('[data-tab]');
      var panels = container.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();

          var targetId = tab.getAttribute('data-tab');

          // Deactivate all tabs and panels
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });

          // Activate clicked tab and corresponding panel
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          var targetPanel = container.querySelector('[data-tab-panel="' + targetId + '"]');
          if (targetPanel) {
            targetPanel.classList.add('is-active');
            targetPanel.removeAttribute('hidden');
          }
        });
      });
    });
  })();

  /* =============================================
   * Quantity Selector
   * ============================================= */
  (function initQuantitySelector() {
    document.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-qty-minus]');
      var plusBtn = e.target.closest('[data-qty-plus]');

      if (!minusBtn && !plusBtn) return;

      var btn = minusBtn || plusBtn;
      var selector = btn.closest('.product-info__qty');
      if (!selector) return;

      var input = selector.querySelector('[data-qty-input]');
      if (!input) return;

      var currentValue = parseInt(input.value, 10) || 1;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10) || 9999;

      if (minusBtn && currentValue > min) {
        input.value = currentValue - 1;
      } else if (plusBtn && currentValue < max) {
        input.value = currentValue + 1;
      }

      // Update the hidden quantity field in the form
      var qtyHidden = document.querySelector('[data-qty-value]');
      if (qtyHidden) {
        qtyHidden.value = input.value;
      }

      // Dispatch change event for any listeners
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  /* =============================================
   * Predictive Search
   * ============================================= */
  (function initPredictiveSearch() {
    var searchInputs = document.querySelectorAll('[data-predictive-search-input]');

    searchInputs.forEach(function (input) {
      var searchWrapper = input.closest('.header__search');
      var resultsContainer = searchWrapper ? searchWrapper.querySelector('[data-predictive-search-results], .predictive-search') : null;
      if (!resultsContainer) return;

      var debounceTimer = null;

      input.addEventListener('input', function () {
        var query = input.value.trim();

        clearTimeout(debounceTimer);

        if (query.length < 3) {
          resultsContainer.innerHTML = '';
          resultsContainer.classList.remove('is-visible');
          return;
        }

        debounceTimer = setTimeout(function () {
          var url = window.Shopify?.routes?.root + 'search/suggest.json?q=' + encodeURIComponent(query)
            + '&resources[type]=product,collection,article'
            + '&resources[limit]=10'
            + '&resources[options][unavailable_products]=last';
          fetch(url)
            .then(function (response) { return response.json(); })
            .then(function (data) {
              var products = data.resources?.results?.products || [];
              var collections = data.resources?.results?.collections || [];
              var articles = data.resources?.results?.articles || [];

              if (products.length === 0 && collections.length === 0 && articles.length === 0) {
                resultsContainer.innerHTML = '<div class="predictive-search__no-results">No results found.<br><small>Try a brand name (Dell, Cisco, Logitech) or category.</small></div>';
                resultsContainer.classList.add('is-visible');
                return;
              }

              var html = '';

              // Products section
              if (products.length > 0) {
                html += '<div class="predictive-search__group"><h4 class="predictive-search__group-title">Products</h4>';
                html += products.slice(0, 6).map(function (product) {
                  var image = product.image ? '<img src="' + product.image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" width="60" height="60" loading="lazy">' : '';
                  return '<a href="' + product.url + '" class="predictive-search__item">' +
                    '<div class="predictive-search__item-image">' + image + '</div>' +
                    '<div class="predictive-search__item-info">' +
                      '<span class="predictive-search__item-title">' + product.title + '</span>' +
                      '<span class="predictive-search__item-price">' + product.price + '</span>' +
                    '</div>' +
                  '</a>';
                }).join('');
                html += '</div>';
              }

              // Collections section
              if (collections.length > 0) {
                html += '<div class="predictive-search__group"><h4 class="predictive-search__group-title">Categories</h4>';
                html += collections.slice(0, 3).map(function (c) {
                  return '<a href="' + c.url + '" class="predictive-search__item predictive-search__item--collection">' +
                    '<span class="predictive-search__item-title">📂 ' + c.title + '</span>' +
                  '</a>';
                }).join('');
                html += '</div>';
              }

              // Articles section
              if (articles.length > 0) {
                html += '<div class="predictive-search__group"><h4 class="predictive-search__group-title">Buyer Guides</h4>';
                html += articles.slice(0, 3).map(function (a) {
                  return '<a href="' + a.url + '" class="predictive-search__item predictive-search__item--article">' +
                    '<span class="predictive-search__item-title">📘 ' + a.title + '</span>' +
                  '</a>';
                }).join('');
                html += '</div>';
              }

              // View all link
              html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="predictive-search__view-all">View all results for "' + query + '" &rarr;</a>';

              resultsContainer.innerHTML = html;
              resultsContainer.classList.add('is-visible');
            })
            .catch(function () {
              resultsContainer.innerHTML = '';
              resultsContainer.classList.remove('is-visible');
            });
        }, 300);
      });

      // Close results when clicking outside
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.header__search')) {
          resultsContainer.innerHTML = '';
          resultsContainer.classList.remove('is-visible');
        }
      });
    });
  })();

  /* =============================================
   * Sticky Add-to-Cart Bar
   * ============================================= */
  (function initStickyAddToCart() {
    var mainAddToCartBtn = document.querySelector('[data-add-to-cart-main]');
    var stickyBar = document.querySelector('[data-sticky-add-to-cart]');

    if (!mainAddToCartBtn || !stickyBar) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          stickyBar.classList.add('is-visible');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    observer.observe(mainAddToCartBtn);
  })();

  /* =============================================
   * Add to Cart AJAX
   * ============================================= */
  (function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"], form[data-product-form]');
      if (!form) return;

      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      var formData = new FormData(form);

      fetch(window.Shopify?.routes?.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || 'Could not add item to cart');
            });
          }
          return response.json();
        })
        .then(function (addedItem) {
          document.dispatchEvent(new CustomEvent('tk:add_to_cart', { detail: { item: addedItem } }));
          return fetch(window.Shopify?.routes?.root + 'cart.js');
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var cartCountElements = document.querySelectorAll('[data-cart-count]');
          cartCountElements.forEach(function (el) {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) {
              el.classList.add('has-items');
            } else {
              el.classList.remove('has-items');
            }
          });

          if (submitBtn) {
            submitBtn.textContent = 'Added!';
            setTimeout(function () {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }, 2000);
          }

          // Refresh bulk-discount progress (5+ items = 5% off)
          if (typeof window.updateBulkDiscountBar === 'function') {
            window.updateBulkDiscountBar(cart.item_count);
          }
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
          if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
          alert(error.message || 'Failed to add item to cart. Please try again.');
        });
    });
  })();

  /* =============================================
   * Cart Page Quantity Buttons + AJAX Cart Update
   * ============================================= */
  (function initCartQuantity() {
    var updateTimeout = null;

    function updateCart(line, quantity) {
      var cartItem = document.querySelector('[data-line-item="' + line + '"]');
      if (cartItem) cartItem.style.opacity = '0.5';

      fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // If quantity is 0, remove the item from DOM
          if (quantity === 0 && cartItem) {
            cartItem.style.transition = 'opacity 0.3s, max-height 0.4s, padding 0.3s, margin 0.3s';
            cartItem.style.opacity = '0';
            cartItem.style.maxHeight = '0';
            cartItem.style.overflow = 'hidden';
            cartItem.style.padding = '0';
            cartItem.style.margin = '0';
            setTimeout(function () {
              cartItem.remove();
              // If cart is empty, reload to show empty state
              if (cart.item_count === 0) {
                window.location.reload();
              }
            }, 400);
          } else if (cartItem) {
            cartItem.style.opacity = '1';
          }

          // Update cart count in header
          var cartCountElements = document.querySelectorAll('[data-cart-count]');
          cartCountElements.forEach(function (el) {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) {
              el.classList.add('has-items');
            } else {
              el.classList.remove('has-items');
            }
          });

          // Update line item price
          if (cartItem && quantity > 0) {
            var priceEl = cartItem.querySelector('.cart-item__price--final');
            if (priceEl) {
              priceEl.textContent = '$' + (cart.items[line - 1].final_line_price / 100).toFixed(2);
            }
          }

          // Update subtotal and total
          var formattedTotal = '$' + (cart.total_price / 100).toFixed(2);
          document.querySelectorAll('.cart-summary__row span:last-child, .cart-summary__row--total strong:last-child').forEach(function (el) {
            el.textContent = formattedTotal;
          });

          // Update cart drawer subtotal if it exists
          var drawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
          if (drawerSubtotal) drawerSubtotal.textContent = formattedTotal;

          // Update free shipping bar if present
          updateFreeShippingBar(cart.total_price);
          // Update bulk discount progress (5+ items = 5% off)
          updateBulkDiscountBar(cart.item_count);
        })
        .catch(function (err) {
          console.error('Cart update error:', err);
          if (cartItem) cartItem.style.opacity = '1';
        });
    }

    function updateFreeShippingBar(totalPrice) {
      var bar = document.querySelector('.free-shipping-bar');
      if (!bar) return;
      var thresholdEl = document.querySelector('[data-free-shipping-threshold]');
      // Try to get threshold from the progress bar or default to 10000 ($100)
      var threshold = thresholdEl ? parseInt(thresholdEl.dataset.freeShippingThreshold, 10) : 10000;
      var remaining = threshold - totalPrice;
      var msgEl = bar.querySelector('.free-shipping-bar__message');
      var fillEl = bar.querySelector('.free-shipping-bar__fill');
      if (remaining > 0) {
        if (msgEl) {
          msgEl.classList.remove('free-shipping-bar__message--success');
          msgEl.textContent = "You're $" + (remaining / 100).toFixed(2) + " away from free shipping!";
        }
        if (fillEl) fillEl.style.width = Math.min((totalPrice / threshold) * 100, 100) + '%';
      } else {
        if (msgEl) {
          msgEl.classList.add('free-shipping-bar__message--success');
          msgEl.textContent = "You've qualified for free shipping!";
        }
        if (fillEl) fillEl.style.width = '100%';
      }
    }

    function updateBulkDiscountBar(itemCount) {
      // Both cart page (.bulk-discount-bar) and cart drawer (.cart-drawer__bulk-discount)
      var THRESHOLD = 5;
      var pct = Math.min((itemCount / THRESHOLD) * 100, 100);
      var unlocked = itemCount >= THRESHOLD;
      var needed = Math.max(THRESHOLD - itemCount, 0);
      var pluralS = needed === 1 ? '' : 's';

      // Cart page version
      var pageBar = document.querySelector('.bulk-discount-bar');
      if (pageBar) {
        var pageMsg = pageBar.querySelector('.bulk-discount-bar__message');
        var pageFill = pageBar.querySelector('.bulk-discount-bar__fill');
        if (pageMsg) {
          if (unlocked) {
            pageMsg.classList.add('bulk-discount-bar__message--success');
            pageMsg.innerHTML = '<span class="bulk-discount-bar__icon">💰</span><span><strong>5% bulk discount applied!</strong> Your order of ' + itemCount + ' items qualifies — discount applied automatically at checkout.</span>';
          } else {
            pageMsg.classList.remove('bulk-discount-bar__message--success');
            pageMsg.innerHTML = '<span class="bulk-discount-bar__icon">💰</span><span>Add <strong>' + needed + '</strong> more item' + pluralS + ' to unlock <strong>5% bulk discount</strong></span>';
          }
        }
        if (pageFill) pageFill.style.width = pct + '%';
      }

      // Cart drawer version
      var drawerBar = document.querySelector('.cart-drawer__bulk-discount');
      if (drawerBar) {
        var drawerMsg = drawerBar.querySelector('.cart-drawer__bulk-msg');
        var drawerFill = drawerBar.querySelector('[data-cart-drawer-bulk-progress]');
        var drawerBarTrack = drawerBar.querySelector('.cart-drawer__bulk-bar');
        if (drawerMsg) {
          if (unlocked) {
            drawerMsg.classList.add('cart-drawer__bulk-msg--unlocked');
            drawerMsg.innerHTML = '<span class="cart-drawer__bulk-icon">💰</span><span><strong>5% bulk discount applied!</strong> Automatically at checkout.</span>';
          } else if (itemCount > 0) {
            drawerMsg.classList.remove('cart-drawer__bulk-msg--unlocked');
            drawerMsg.innerHTML = '<span class="cart-drawer__bulk-icon">💰</span><span>Add <strong>' + needed + '</strong> more item' + pluralS + ' for <strong>5% off</strong></span>';
          } else {
            drawerMsg.innerHTML = '';
          }
        }
        if (drawerFill) drawerFill.style.width = pct + '%';
        if (drawerBarTrack) drawerBarTrack.style.display = itemCount > 0 ? '' : 'none';
      }
    }
    // Expose for cart drawer JS to call after any cart change
    window.updateBulkDiscountBar = updateBulkDiscountBar;

    // Handle +/- button clicks
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quantity-selector__btn');
      if (!btn) return;

      var selector = btn.closest('.quantity-selector');
      if (!selector) return;

      var input = selector.querySelector('.quantity-selector__input');
      if (!input) return;

      var currentValue = parseInt(input.value, 10) || 1;
      var action = btn.getAttribute('data-action');

      if (action === 'decrease' && currentValue > 0) {
        input.value = currentValue - 1;
      } else if (action === 'increase') {
        input.value = currentValue + 1;
      }

      var line = parseInt(input.getAttribute('data-line'), 10);
      var newQty = parseInt(input.value, 10);

      if (line) {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(function () {
          updateCart(line, newQty);
        }, 300);
      }
    });

    // Handle manual quantity input changes
    document.addEventListener('change', function (e) {
      var input = e.target.closest('.quantity-selector__input');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-line'), 10);
      var newQty = parseInt(input.value, 10) || 0;
      if (line) {
        updateCart(line, newQty);
      }
    });

    // Handle remove button clicks via AJAX instead of page redirect
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.cart-item__remove');
      if (!removeBtn) return;
      e.preventDefault();
      var cartItem = removeBtn.closest('[data-line-item]');
      if (!cartItem) return;
      var line = parseInt(cartItem.getAttribute('data-line-item'), 10);
      updateCart(line, 0);
    });
  })();

  /* =============================================
   * Product Description / Specifications Splitter
   * Automatically separates spec content from description
   * and moves it to the Specifications tab
   * ============================================= */
  (function initDescSpecSplitter() {
    var descContainer = document.querySelector('[data-full-description]');
    var specsContainer = document.querySelector('[data-extracted-specs]');
    if (!descContainer || !specsContainer) return;

    // Work on a temporary DOM fragment so we can rearrange nodes
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = descContainer.innerHTML;

    // Remove any <title> tags that shouldn't be in the body
    var titleEls = tempDiv.querySelectorAll('title');
    titleEls.forEach(function (t) { t.remove(); });

    // Collect all child nodes and classify them
    var descNodes = [];
    var specNodes = [];
    var hitSpecSection = false;

    var children = Array.prototype.slice.call(tempDiv.childNodes);

    children.forEach(function (node) {
      // Skip empty text nodes
      if (node.nodeType === 3 && node.textContent.trim() === '') return;

      var tagName = node.tagName ? node.tagName.toUpperCase() : '';
      var textContent = (node.textContent || '').trim().toLowerCase();

      // Detect "Specifications:" heading - everything after goes to specs
      if ((tagName === 'H3' || tagName === 'H2' || tagName === 'H4' || tagName === 'STRONG' || tagName === 'B') &&
          (textContent.indexOf('specification') !== -1 || textContent.indexOf('specs') !== -1 ||
           textContent.indexOf('technical detail') !== -1 || textContent.indexOf('tech specs') !== -1)) {
        hitSpecSection = true;
        // Don't include the heading itself, we have our own in the Specs tab
        return;
      }

      // Check if a <p> contains a specs heading like <strong>Specifications:</strong>
      if (tagName === 'P' && node.querySelector) {
        var innerStrong = node.querySelector('strong, b');
        if (innerStrong) {
          var strongText = innerStrong.textContent.trim().toLowerCase();
          if (strongText.indexOf('specification') !== -1 || strongText.indexOf('tech specs') !== -1) {
            hitSpecSection = true;
            return;
          }
        }
      }

      // Tables always go to specifications
      if (tagName === 'TABLE') {
        specNodes.push(node.cloneNode(true));
        return;
      }

      // Unordered/ordered lists go to specifications
      if (tagName === 'UL' || tagName === 'OL') {
        specNodes.push(node.cloneNode(true));
        return;
      }

      // Check if a <p> contains bullet-point-style content (• character)
      if (tagName === 'P') {
        var html = node.innerHTML || '';
        var bulletCount = (html.match(/•/g) || []).length;
        // If paragraph has 3+ bullet points, treat as specs
        if (bulletCount >= 3) {
          // Convert bullet text to a proper list
          var listItems = html.split(/•/).filter(function (item) {
            return item.replace(/<[^>]*>/g, '').trim() !== '';
          });
          if (listItems.length > 0) {
            var ul = document.createElement('ul');
            ul.className = 'specs-list';
            listItems.forEach(function (item) {
              var li = document.createElement('li');
              // Clean up <br> tags and <span> wrappers
              li.innerHTML = item.replace(/<br\s*\/?>/gi, '').trim();
              if (li.textContent.trim() !== '') {
                ul.appendChild(li);
              }
            });
            specNodes.push(ul);
          }
          return;
        }
      }

      // If we've passed a specs heading, remaining content goes to specs
      if (hitSpecSection) {
        // But trailing descriptive paragraphs (short, no bullet points) go back to description
        if (tagName === 'P' && !node.querySelector('table') && textContent.length > 20 && textContent.indexOf('•') === -1) {
          descNodes.push(node.cloneNode(true));
        } else if (tagName === 'BR' || (node.nodeType === 3 && textContent === '')) {
          // Skip lone <br> tags and empty text nodes
        } else {
          specNodes.push(node.cloneNode(true));
        }
        return;
      }

      // Everything else before the spec section is description
      if (tagName !== 'BR' || descNodes.length > 0) {
        descNodes.push(node.cloneNode(true));
      }
    });

    // Only apply changes if we found spec content to move
    if (specNodes.length > 0) {
      // Rebuild the description tab with only description content
      descContainer.innerHTML = '';
      descNodes.forEach(function (node) {
        descContainer.appendChild(node);
      });

      // If description is empty after splitting, show a brief summary
      if (descContainer.textContent.trim() === '') {
        var productTitle = document.querySelector('.product-info__title');
        if (productTitle) {
          var p = document.createElement('p');
          p.textContent = productTitle.textContent.trim();
          descContainer.appendChild(p);
        }
      }

      // Build the extracted specs section
      var specsWrapper = document.createElement('div');
      specsWrapper.className = 'rte';

      specNodes.forEach(function (node) {
        // Style tables consistently
        if (node.tagName === 'TABLE') {
          node.className = 'specs-table';
          node.removeAttribute('width');
          node.removeAttribute('border');
          node.removeAttribute('cellspacing');
          node.removeAttribute('cellpadding');
          node.style.cssText = '';
          // Clean up inline styles on table cells
          var cells = node.querySelectorAll('td, th');
          cells.forEach(function (cell) {
            cell.style.cssText = '';
          });
        }
        specsWrapper.appendChild(node);
      });

      specsContainer.appendChild(specsWrapper);
    }
  })();

  // ===== Bulk Buy Toggle =====
  (function () {
    var toggleBtn = document.querySelector('[data-bulk-buy-toggle]');
    var form = document.querySelector('[data-bulk-buy-form]');
    var closeBtn = document.querySelector('[data-bulk-buy-close]');

    if (toggleBtn && form) {
      toggleBtn.addEventListener('click', function () {
        form.style.display = form.style.display === 'none' ? 'block' : 'none';
        if (form.style.display === 'block') {
          form.querySelector('input[name="contact[name]"]').focus();
        }
      });
    }

    if (closeBtn && form) {
      closeBtn.addEventListener('click', function () {
        form.style.display = 'none';
      });
    }
  })();

  // ===== Frequently Bought Together =====
  (function () {
    var fbtCheckboxes = document.querySelectorAll('[data-fbt-checkbox]');
    var fbtTotalEl = document.querySelector('[data-fbt-total]');
    var fbtAddAllBtn = document.querySelector('[data-fbt-add-all]');

    if (!fbtTotalEl || fbtCheckboxes.length === 0) return;

    var basePrice = parseInt(fbtTotalEl.getAttribute('data-base-price'), 10);

    function updateFbtTotal() {
      var total = basePrice;
      fbtCheckboxes.forEach(function (cb) {
        if (cb.checked) {
          total += parseInt(cb.getAttribute('data-fbt-price'), 10);
        }
      });
      // Format as money (cents to dollars)
      var formatted = '$' + (total / 100).toFixed(2);
      fbtTotalEl.textContent = formatted;
    }

    fbtCheckboxes.forEach(function (cb) {
      cb.addEventListener('change', updateFbtTotal);
    });

    if (fbtAddAllBtn) {
      fbtAddAllBtn.addEventListener('click', function () {
        var items = [];
        // Add current product
        var mainVariantId = document.querySelector('[data-variant-id]');
        if (mainVariantId) {
          items.push({ id: parseInt(mainVariantId.value, 10), quantity: 1 });
        }
        // Add checked FBT products
        fbtCheckboxes.forEach(function (cb) {
          if (cb.checked) {
            items.push({ id: parseInt(cb.getAttribute('data-fbt-variant-id'), 10), quantity: 1 });
          }
        });

        if (items.length === 0) return;

        fbtAddAllBtn.disabled = true;
        fbtAddAllBtn.textContent = 'Adding...';

        // Add items sequentially
        var addNextItem = function (index) {
          if (index >= items.length) {
            fbtAddAllBtn.disabled = false;
            fbtAddAllBtn.textContent = 'Added! ✓';
            // Update cart count
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var countEl = document.querySelector('[data-cart-count]');
                if (countEl) countEl.textContent = cart.item_count;
              });
            setTimeout(function () {
              fbtAddAllBtn.textContent = 'Add All to Cart';
            }, 2000);
            return;
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: items[index].id, quantity: items[index].quantity })
          })
            .then(function () { addNextItem(index + 1); })
            .catch(function () { addNextItem(index + 1); });
        };
        addNextItem(0);
      });
    }
  })();
});
